export const ADD_PREDICTIVE_WORD = 'ADD_PREDICTIVE_WORD'
export const INCREASE_SPEED = 'INCREASE_SPEED'
export const PUCK_ACTIVATED = 'PUCK_ACTIVATED'
export const PUCK_ACTIVATING = 'PUCK_ACTIVATING'
export const PUCK_ACTIVATION_FAILED = 'PUCK_ACTIVATION_FAILED'
export const REDUCE_SPEED = 'REDUCE_SPEED'
export const SELECT = 'SELECT'
export const SET_ACTIVE_COLUMN = 'SET_ACTIVE_COLUMN'
export const SET_OUTPUT = 'SET_OUTPUT'
export const SET_SETTING = 'SET_SETTING'
export const START_TICK = 'START_TICK'
export const STOP_TICK = 'STOP_TICK'
export const TOGGLE_CAPS_LOCK = 'TOGGLE_CAPS_LOCK'
export const TICK = 'TICK'
export const UPDATE_OUTPUT = 'UPDATE_OUTPUT'
export const UPDATE_SUGGESTED_WORDS = 'UPDATE_SUGGESTED_WORDS'



// WEBPACK FOOTER //
// ./src/actions/action-types.js